module.exports = __webpack_public_path__ + "static/images/404.2ff881a5.jpg";